import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getAvailableLanguages } from '../../features/app/selectors';
import ImmutablePropsToJS from '../../utils/ImmutablePropsToJS';
import Prompt from './Prompt';
import PromptContext from './PromptContext';

class PromptProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      activeStep: 0,
      steps: [],
      data: null,
      promptState: {},
      onCancel: null,
      onDone: null
    };
  }

  getLanguages = () => {
    const { languages, intl } = this.props;
    const languagesWithNames = languages.map(language => ({
      code: language,
      name: intl.formatMessage({ id: `internationalization.${language}` })
    }));
    return languagesWithNames;
  };

  open = ({
    steps = [],
    data,
    onCancel = () => {},
    onDone = () => {}
  } = {}) => {
    const stepsWithNumbers = steps.map((step, i) => ({ ...step, number: i }));
    this.setState({
      isOpen: true,
      steps: stepsWithNumbers,
      data,
      onCancel,
      onDone
    });
  };

  close = () => {
    this.setState({ isOpen: false, activeStep: 0 });
  };

  validateStep = number => {
    const { steps, promptState: state } = this.state;
    const { setPromptState: setState } = this;
    const languages = this.getLanguages();
    const stepToValidate = steps.find(step => step.number === number);
    return stepToValidate.validate({ state, languages, setState });
  };

  cancel = () => {
    this.close();
    const { onCancel } = this.state;
    onCancel();
  };

  done = () => {
    const { onDone, promptState, activeStep } = this.state;
    if (!this.validateStep(activeStep)) {
      return;
    }
    this.close();
    onDone({ promptState });
    this.setState({ promptState: {} });
  };

  nextStep = () => {
    const { activeStep } = this.state;
    if (!this.validateStep(activeStep)) {
      return;
    }
    this.setState({ activeStep: activeStep + 1 });
  };

  setPromptState = promptState => {
    const { promptState: existingPromptState } = this.state;
    const newPromptState = _.merge({}, existingPromptState, promptState);
    this.setState({ promptState: newPromptState });
  };

  render() {
    const { children } = this.props;
    const { isOpen, steps, activeStep, data, promptState } = this.state;
    return (
      <PromptContext.Provider
        value={{
          open: this.open
        }}
      >
        <Prompt
          isOpen={isOpen}
          steps={steps}
          activeStep={activeStep}
          data={data}
          promptState={promptState}
          setPromptState={this.setPromptState}
          onCancel={this.cancel}
          onDone={this.done}
          onNext={this.nextStep}
        />
        {children}
      </PromptContext.Provider>
    );
  }
}

export default injectIntl(
  connect(state => ({ languages: getAvailableLanguages(state) }))(
    ImmutablePropsToJS(PromptProvider)
  )
);
